import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Tooltip } from "primereact/tooltip";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import PrimeDialog from "../../../components/dialog/PrimeDialog";
import NoInfo from "../../../components/NoInfo";
import PrimeTableFooter from "../../../components/PrimeTableFooter";
import NumberUtil from "../../../utility/NumberUtil";

export const TotalCarbonTable = ({ rows, btnReadMore, editItem }) => {
  const { t } = useTranslation();
  const [calculationAuditFlag, setCalculationAuditFlag] = useState(false);
  const [calculationAuditLogList, setCalculationAuditLsit] = useState([]);

  const actionBodyTemplate = (rowData) => {
    if (rowData) {
      return (
        <>
          <Button
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            tooltip={t("button.detail")}
            onClick={() => {
              editItem(rowData);
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-eye" />
          </Button>
          {rowData?.calculationAuditLogList !== null && rowData.calculationAuditLogList.length > 0 && (
            <Button
              icon="pi pi-history"
              label={rowData?.detailCase}
              className="p-button-icon-only"
              tooltip={t("calculationProcess")}
              tooltipOptions={{ position: "top" }}
              rounded
              text
              severity="secondary"
              size="small"
              onClick={() => {
                handleCalculationAuditLog(rowData);
              }}
            />
          )}
        </>
      );
    }
  };

  const transErrorValueTag = (rowData, props) => {
    if (!rowData || !props?.field) return null;

    const value = rowData[props.field];
    if (!value) return null;

    const formattedValue = NumberUtil.formatWithCommas(value.replace("!", ""));

    const indicesWithError = rowData.errorMsg.map((msg) => msg.errorMsg);

    return (
      <>
        <Tooltip target=".form-exclamation" position="top" />
        <span className={value.includes("!") ? "form-exclamation" : ""} data-pr-tooltip={indicesWithError.join("\n")}>
          {formattedValue}
        </span>
      </>
    );
  };

  const handleCalculationAuditLog = (rowData) => {
    setCalculationAuditFlag(true);
    setCalculationAuditLsit(rowData.calculationAuditLogList);
  };

  const operationBodyTemplate = (value) => {
    switch (value) {
      case "add":
        return <FontAwesomeIcon icon="fa-solid fa-plus" />;
      case "subtract":
        return <FontAwesomeIcon icon="fa-solid fa-minus" />;
      case "multiply":
        return <FontAwesomeIcon icon="fa-solid fa-multiply" />;
      case "divide":
        return <FontAwesomeIcon icon="fa-solid fa-divide" />;
      default:
        return <FontAwesomeIcon icon="fa-solid fa-equals" />;
    }
  };

  return (
    <>
      <DataTable
        stripedRows
        value={rows}
        className="white-data-table hover-highlight no-shadow mt-1"
        tableStyle={{ minWidth: "50rem" }}
        footer={
          rows?.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={false} btnReadMore={btnReadMore} />
        }
        emptyMessage={<NoInfo panel="table" size="md" />}
      >
        <Column header={t("itemNo")} body={(rowData, { rowIndex }) => `${rowIndex + 1}`} />
        <Column field="stageName" header={t("lifeCycleStage")} />
        <Column field="dataName" header={t("activityDataName")} />
        <Column
          field="dataValue"
          style={{ textAlign: "right" }}
          headerStyle={{ textAlign: "right" }}
          headerClassName="right-header"
          body={(rowData, props) => {
            return (
              <>
                <div>{NumberUtil.formatWithCommas(rowData?.unitQuantity)}</div>
                <div>{rowData?.dataUnitName}</div>
              </>
            );
          }}
          header={
            <>
              {t("quantityPerUnit")}
              <br />({t("unit")})
            </>
          }
        />
        {/* <Column field="emissionCoefficientName" header="排放係數名稱"></Column> */}
        <Column
          field="dataUnitName"
          style={{ textAlign: "right" }}
          headerStyle={{ textAlign: "right" }}
          headerClassName="right-header"
          body={(rowData, props) => {
            return (
              <>
                <div>{NumberUtil.formatWithCommas(rowData?.coefValue)}</div>
                <div>{rowData?.coefUnitName}</div>
              </>
            );
          }}
          header={
            <>
              {t("emissionFactor")}
              <br />({t("unit")})
            </>
          }
        />
        <Column
          field="unitValue"
          body={transErrorValueTag}
          header={<>{t("carbon_footprint")}</>}
          style={{ textAlign: "right" }}
          headerStyle={{ textAlign: "right" }}
          headerClassName="right-header"
        />
        <Column
          field="cfRatio"
          body={transErrorValueTag}
          header={t("carbonFootprintProportion")}
          style={{ textAlign: "right" }}
          headerStyle={{ textAlign: "right" }}
          headerClassName="right-header"
        />
        <Column header={t("action")} body={actionBodyTemplate} />
        {/* <Column style={{width:'80px'}} field="activityDataValue" header="數值"></Column>
            <Column field="emissionCoefficientUnit" header="單位"></Column> */}
      </DataTable>

      {/* 計算過程 */}
      <PrimeDialog
        visible={calculationAuditFlag}
        onClose={() => {
          setCalculationAuditFlag(false);
        }}
        draggable={true}
        resizable={true}
        isShowConfBtn={false}
        isShowDelBtn={false}
        title={`${t("calculationProcess")}`}
        bodyTemplate={
          <DataTable
            className="white-data-table hover-highlight no-shadow"
            value={calculationAuditLogList}
            emptyMessage={t("no_rec")}
            rowGroupMode="rowspan"
            groupRowsBy="gasCode"
          >
            <Column field="gasCode" header={t("gasCode")} />
            <Column field="valueA" />
            <Column field="operation" body={(rowData) => operationBodyTemplate(rowData?.operation)} />
            <Column field="valueB" />
            <Column body={(rowData) => operationBodyTemplate("")} />
            <Column field="result" header={t("result")} />
            <Column field="remark" header={t("remark")} body={(rowData) => t(`calculationRemark.${rowData?.remark}`)} />
          </DataTable>
        }
      />
    </>
  );
};

export default TotalCarbonTable;
